export const shouldTruncateElement = (element: HTMLElement): boolean => {
  return element.scrollWidth > element.clientWidth
}
